import { RetryPlugin } from "@module-federation/retry-plugin";

// Module federation plugin for refetching failed remote modules
const retryPlugin = () =>
    RetryPlugin({
        fetch: {
            retryDelay: 2000,
            retryTimes: 3,
        },
        script: {
            retryDelay: 2000,
            retryTimes: 3,
        },
    });

export default retryPlugin;
